/**
 * Returns list of fields to query
 */
const getFields = () => {
  return ['point_code', 'PointID', 'equipment_type', 'unit_type', 'unit_account_name', 'HeightDistance', 'LogName'];
};

/**
 * Returns list of fields for filters
 */
const getFieldsForFilters = () => {
  return ['point_code', 'PointID', 'equipment_type', 'unit_type', 'unit_account_name', 'LogName'];
};

export { getFields, getFieldsForFilters };